import type { Options } from "@hey-api/client-fetch";
import {
  useMutation,
  useMutationState,
  useQueryClient,
} from "@tanstack/react-query";
import type {
  PostV1LinksByProfileLinkContactsData,
  PostV1LinksByProfileLinkContactsError,
  PostV1LinksByProfileLinkContactsResponse,
} from "../../client";
import {
  postV1LinksByProfileLinkContactsMutation,
  putV1LinksByProfileLinkMutation,
} from "../../client/@tanstack/react-query.gen";
import { getLinkOptions } from "./get-link";

const mutationKey = ["updateLink"];

const getLinkQueryKey = (profileLink: string) =>
  getLinkOptions(profileLink).queryKey;

export const useCreateSalesContact = () => {
  const queryClient = useQueryClient();
  return useMutation<
    PostV1LinksByProfileLinkContactsResponse,
    PostV1LinksByProfileLinkContactsError,
    Options<PostV1LinksByProfileLinkContactsData>
  >({
    ...postV1LinksByProfileLinkContactsMutation(),
    mutationKey,
    onSettled: async (_, __, { path: { profileLink } }) => {
      /*
      await queryClient.invalidateQueries({
        queryKey: getLinkQueryKey(profileLink),
      });
      */
    },
  });
};
